var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestoreArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 9) translate(0 4)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M21.622 9.081C21.622 4.066 17.556 0 12.54 0 7.525 0 3.459 4.066 3.459 9.081",
    transform: "translate(0 .19)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M0 10.378L3.459 13.838 6.919 10.378M3.459 8.649L3.459 13.838",
    transform: "translate(0 .19)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8 9)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.733 19.333v7.6c0 1.4-1.134 2.534-2.533 2.534H2.8c-1.4 0-2.533-1.135-2.533-2.534v-7.6M16.267 12.013L10.2 1.505C9.942 1.06 9.242.98 8.636 1.33L6.442 2.597l7 12.124 2.194-1.266c.606-.35.888-.996.63-1.442z",
    transform: "translate(15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.033 23.6c0 .7-.567 1.267-1.266 1.267H7.233c-.7 0-1.266-.567-1.266-1.267s.567-1.267 1.266-1.267h2.534c.7 0 1.266.567 1.266 1.267z",
    transform: "translate(15)"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18 19L29 19",
    transform: "translate(8 9)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreArchive);
export default __webpack_public_path__ + "static/media/restore_archive.6686bdeebd287091e17a59bb06b4f8ff.svg";
export { ForwardRef as ReactComponent };